import Home from '../pages/Vendor/Home/index';
import MyDownloads from 'src/pages/Vendor/My-Downloads';
import MyContacts from 'src/pages/Vendor/My-Contacts';
import MyProfile from 'src/pages/Vendor/My-Profile';
import SearchBidsPage from 'src/pages/Admin/Home';
import BidManagement from 'src/pages/Admin/Modify-Bid';
import VendorManagement from 'src/pages/Admin/Vendors';
import UserProfile from 'src/pages/Admin/My-Profile';
import BidCategories from 'src/pages/Admin/Settings/BId-Categories';
import BidDepartments from 'src/pages/Admin/Settings/Bid-Departments';
import BidStatus from 'src/pages/Admin/Settings/Bid-Status';
import BidTypeMaster from 'src/pages/Admin/Settings/Bid-Type';
import MemberMaster from 'src/pages/Admin/Settings/Manage-Users';
import BidCreationForm from 'src/pages/Admin/Home/Create-Bid';
import VendorRegistration from 'src/pages/Admin/Vendors/Create-Vendor';
import ChangePassword from 'src/pages/Admin/My-Profile/Change-Password';
import BidUpdationForm from 'src/pages/Admin/Home/Update-Bid';
import ShowDownloads from 'src/pages/Vendor/My-Downloads/ShowDownloads';
import EmailTemplates from 'src/pages/Admin/Settings/Email-Templates';
import BidSummary from 'src/pages/Admin/Reports/Bid-Summary';
import UserActivity from 'src/pages/Admin/Reports/User-Activity';
import Vendors from 'src/pages/Admin/Reports/Vendors';
import Dashboard from 'src/pages/Admin/Dashboard';
import ChangeVendorPassword from 'src/pages/Vendor/My-Profile/Chane-password';
import BidNotifications from 'src/pages/Admin/Bid-Notifications';
import BidChildUpdationForm from 'src/pages/Admin/Home/Update-ChildBid';
import BidDetails from 'src/pages/Vendor/Home/BidDetails';
import UploadPOFIle from 'src/pages/Vendor/Home/UploadPoFIle';
import MyContracts from 'src/pages/Vendor/My-Contracts';
import AuthNotifications from 'src/pages/Admin/Reports/Auth-Notifications';

export const privateRoutes = [
  {
    path: '/:state/:township/:uuid/bid-portal/home',
    element: <Home />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/home/bid-details/:bidID',
    element: <BidDetails />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/home/po-details/:bidId',
    element: <UploadPOFIle />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/downloads',
    element: <MyDownloads />
  },

  {
    path: '/:state/:township/:uuid/bid-portal/contracts',
    element: <MyContracts />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/downloads/details',
    element: <ShowDownloads />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/contacts',
    element: <MyContacts />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/profile',
    element: <MyProfile />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/home',
    element: <SearchBidsPage />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/modifybids',
    element: <BidManagement />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/vendors',
    element: <VendorManagement />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/my-profile',
    element: <UserProfile />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/bid-categories',
    element: <BidCategories />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/bid-departments',
    element: <BidDepartments />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/bid-status',
    element: <BidStatus />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/bid-type',
    element: <BidTypeMaster />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/manage-users',
    element: <MemberMaster />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/home/create-bid',
    element: <BidCreationForm />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/vendors/registration',
    element: <VendorRegistration />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/vendors/edit/:UserID',
    element: <VendorRegistration />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/vendors/edit/:UserID',
    element: <VendorRegistration />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/my-profile/change-password',
    element: <ChangePassword />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/profile/change-password',
    element: <ChangeVendorPassword />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/home/edit-bid/:bidId',
    element: <BidUpdationForm />
  },

  {
    path: '/:state/:township/:uuid/bid-portal/Admin/home/edit-child-bid/:bidId/:childBidId',
    element: <BidChildUpdationForm />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/email-templates',
    element: <EmailTemplates />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/bid-summary',
    element: <BidSummary />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/user-activity',
    element: <UserActivity />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/report-vendors',
    element: <Vendors />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/dashboard',
    element: <Dashboard />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/bid-notifications',
    element: <BidNotifications />
  },
  {
    path: '/:state/:township/:uuid/bid-portal/Admin/auth-notifications',
    element: <AuthNotifications />
  }
];
